import { Badge } from '@/components/ui/badge';
import { ConfidenceLevel, getConfidenceColor } from '@/lib/deduplication-utils';
import { cn } from '@/lib/utils';

interface ConfidenceBadgeProps {
  confidence: ConfidenceLevel;
  score: number;
  showScore?: boolean;
  className?: string;
}

export function ConfidenceBadge({ confidence, score, showScore = true, className }: ConfidenceBadgeProps) {
  const labels: Record<ConfidenceLevel, string> = {
    high: 'High Match',
    medium: 'Medium Match',
    low: 'Low Match',
    none: 'No Match',
  };

  return (
    <Badge 
      className={cn(getConfidenceColor(confidence), className)}
      variant="secondary"
    >
      {labels[confidence]}
      {showScore && ` (${score}%)`}
    </Badge>
  );
}
